import {useQuery} from '@tanstack/react-query'
import {useAccessToken, useCommerceApi} from '@salesforce/commerce-sdk-react'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import CustomApi from './use-custom-api'

const useCustomerGroups = () => {
    const {getTokenWhenReady} = useAccessToken()
    const {data: customer} = useCurrentCustomer()
    const customApi = new CustomApi()
    const api = useCommerceApi()
    const {proxy} = api.shopperExperience.clientConfig

    const fetchGroupIds = async () => {
        const token = await getTokenWhenReady()
        const apiName = 'customer-groups'
        const endpointPath = '/'
        const response = await customApi.get(token, apiName, endpointPath, {}, proxy)
        return response
    }

    return useQuery({
        queryKey: ['use-customer-groups', customer.isRegistered],
        queryFn: () => fetchGroupIds(),
        enabled: true,
        refetchOnMount: false,
        keepPreviousData: false,
        refetchOnReconnect: false
    })
}

export default useCustomerGroups
